var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrinterGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.83337 4.66668H11.1667V3.33334C11.1667 2.00001 10.6667 1.33334 9.16671 1.33334H6.83337C5.33337 1.33334 4.83337 2.00001 4.83337 3.33334V4.66668Z",
    stroke: "rgba(43,43,43,1)",
    strokeWidth: 0.96,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 10V12.6667C10.6667 14 10 14.6667 8.66671 14.6667H7.33337C6.00004 14.6667 5.33337 14 5.33337 12.6667V10H10.6667Z",
    stroke: "rgba(43,43,43,1)",
    strokeWidth: 0.96,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 6.66666V9.99999C14 11.3333 13.3333 12 12 12H10.6667V9.99999H5.33333V12H4C2.66667 12 2 11.3333 2 9.99999V6.66666C2 5.33332 2.66667 4.66666 4 4.66666H12C13.3333 4.66666 14 5.33332 14 6.66666Z",
    stroke: "rgba(43,43,43,1)",
    strokeWidth: 0.96,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 10H10.5266H4.66663",
    stroke: "rgba(43,43,43,1)",
    strokeWidth: 0.96,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66663 7.33334H6.66663",
    stroke: "rgba(43,43,43,1)",
    strokeWidth: 0.96,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinterGrey);
export default __webpack_public_path__ + "static/media/printer-grey.22e1ee4a978d397ff33bd999f3c89237.svg";
export { ForwardRef as ReactComponent };